import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { PageHeader } from "@/components/shared/PageHeader";
import { EmptyState } from "@/components/shared/States";
import { StaggerGroup, StaggerItem } from "@/components/shared/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { fetchContent } from "@/lib/contentApi";

export default function StudentSuccess() {
  useSeo("Student Success", "Real ASAI student stories and testimonials.");
  const [items, setItems] = useState(null);
  useEffect(() => { fetchContent("testimonials").then(setItems).catch(() => setItems([])); }, []);

  return (
    <div data-testid="page-student-success">
      <PageHeader overline="Student Success" titleLines={["Real stories", "from our learners"]} description="Authentic experiences from ASAI students. We only publish verified, approved testimonials." />
      <section className="bg-white py-16 md:py-24">
        <div className="container-asai">
          {items === null ? null : items.length === 0 ? (
            <EmptyState title="Student stories coming soon" description="We&apos;re collecting authentic testimonials from our students. Verified stories will appear here soon — we never publish fake reviews." />
          ) : (
            <StaggerGroup className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="testimonials-grid">
              {items.map((t) => (
                <StaggerItem key={t.id} className="flex flex-col gap-4 rounded-2xl border border-navy/10 bg-lightgrey p-7">
                  {t.rating && <div className="flex gap-0.5">{Array.from({ length: 5 }).map((_, i) => <Star key={i} className={`h-4 w-4 ${i < t.rating ? "fill-orange text-orange" : "text-navy/20"}`} />)}</div>}
                  {t.videoUrl ? (
                    <video src={t.videoUrl} controls className="w-full rounded-lg" />
                  ) : (
                    <p className="font-heading text-lg leading-snug text-navy/85">&ldquo;{t.text}&rdquo;</p>
                  )}
                  <div className="mt-auto flex items-center gap-3">
                    {t.photo ? <img src={t.photo} alt={t.name} className="h-11 w-11 rounded-full object-cover" /> : <div className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-white">{(t.name || "S")[0]}</div>}
                    <div><div className="text-sm font-semibold text-navy">{t.name}</div><div className="text-xs text-navy/55">{[t.course, t.college].filter(Boolean).join(" · ")}</div></div>
                  </div>
                </StaggerItem>
              ))}
            </StaggerGroup>
          )}
        </div>
      </section>
    </div>
  );
}
